<head>
  <!-- Matomo Tag Manager -->
  <script>
    var _mtm = window._mtm = window._mtm || [];
    _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; g.src='http://10.171.80.34:9603/js/container_akjXKwvF.js'; s.parentNode.insertBefore(g,s);
    </script>
    <!-- End Matomo Tag Manager -->
  </head>

<div class="po-wrapper">

    <po-toolbar 
      p-title="EngPro Service Provider"
      p-actions-icon="po-icon-help"
      [p-profile]="toolbarProfile"
      p-profile-icon="po-icon-user"
      (click)="handleProfileClick($event)"
      >
    </po-toolbar>

    <po-menu
      [p-menus]="menu"
      p-logo="../../../assets/images/menu-header.png"
      p-short-logo="../../favicon.ico">
    </po-menu>

    <router-outlet></router-outlet>
  </div>

  <po-modal #cadastraArea
  p-title="Selecione sua área"
  p-size="md"
  [p-hide-close]="true"
  [p-click-out]="false"
  [p-primary-action]="saveArea">

  <div class="po-row">
    <p class="po-font-text po-md-12 area-modal-intro">
      Escolha a área em que você atua para continuar. A tribe é definida pela área escolhida.
    </p>
  </div>

  <div class="po-row">
    <po-combo
      class="po-md-12"
      name="listaArea"
      [(ngModel)]="areaSelected"
      (p-change)="onAreaSelected($event)"
      p-label="Área"
      [p-placeholder]="areaPlaceholder"
      p-filter-mode="contains"
      p-icon="po-icon-search"
      [p-auto-focus]="true"
      [p-clean]="true"
      [p-required]="true"
      [p-disabled]="areasLoading || areasLoadFailed || saveArea.loading"
      [p-options]="areas">
    </po-combo>
  </div>

  <div class="po-row" *ngIf="areasLoadFailed">
    <div class="po-md-12 area-modal-error" role="alert">
      <span class="po-font-text">Não foi possível carregar a lista de áreas.</span>
      <po-button
        p-label="Tentar novamente"
        p-icon="po-icon-refresh"
        p-kind="tertiary"
        p-size="small"
        (p-click)="getAreas()">
      </po-button>
    </div>
  </div>

  <div class="po-row" *ngIf="areaSelected">
    <div class="po-md-12 area-modal-tribe" aria-live="polite">
      <label class="po-label area-modal-tribe-label" p-field="true">Tribe</label>
      <po-tag
        *ngIf="selectedTribe; else noTribe"
        [p-value]="selectedTribe"
        p-color="color-08"
        p-icon="po-icon-users">
      </po-tag>
      <ng-template #noTribe>
        <span class="po-font-text-small area-modal-tribe-empty">Esta área ainda não está vinculada a uma tribe.</span>
      </ng-template>
    </div>
  </div>

</po-modal>


  <po-modal #getPATAToken 
  p-title="Token - VS Code"
  p-click-out=true>

  <div class="sample-container" *ngIf="tokenExists">
    
    <po-info
      class="po-md-9 thf-mb-sm-6 thf-mb-md-9 thf-lb-lg-9"
      p-label="Usuário"
      p-orientation="horizontal"
      [p-value]="tokenUser">
    </po-info>

    <po-info
      class="po-md-9 thf-mb-sm-6 thf-mb-md-9 thf-lb-lg-9"
      p-label="Data de criação"
      p-orientation="horizontal"
      [p-value]="tokenDate">
    </po-info>

    <po-textarea
      class="po-sm-12"
      name="token"
      [(ngModel)]="tokenData"
      p-label="Token:"
      p-readonly
      p-rows="4">
    </po-textarea>

    <br>

    <po-button
      class="po-lg-12 po-mt-2"
      (p-click)="deletePATAToken()"
      p-label="Deletar Token!" >
    </po-button>

  </div>

  <div class="sample-container" *ngIf="!tokenExists">
    <po-info
      class="po-md-9 thf-mb-sm-6 thf-mb-md-9 thf-lb-lg-9"
      p-label="Para gerar o token preencha as informações abaixo:">
    </po-info>
    <br>
    <po-input
      class="po-md-12"
      p-clean
      p-icon="po-icon-user"
      p-label="Username"
      [(ngModel)]="tUsername">
    </po-input>

    <po-password
      class="po-sm-12"
      [(ngModel)]="tPassword"
      p-clean
      p-label="Senha"
      p-required>
    </po-password>
    
    <po-button
      class="po-lg-12 po-mt-2"
      (p-click)="generatePATAToken()"
      p-label="Gerar Token!" >
    </po-button>

    <po-textarea
      class="po-sm-12"
      name="token"
      [(ngModel)]="tokenData"
      p-label="Token:"
      p-readonly
      p-rows="4">
    </po-textarea>
  </div>
  
</po-modal>

<po-modal #getCompileKey
  p-title="Compile Key"
  p-hide-close="true"
  [p-primary-action]="closeCompileKeyAction"
>

  <po-container
    class="token-container"
    [p-height]="320" 
    [p-no-border]="true" 
    [p-no-padding]="true"
  >
    <div *ngIf="compileKey?.token">
      <po-info
        class="po-md-9 thf-mb-sm-6 thf-mb-md-9 thf-lb-lg-9"
        p-label="Emitido por"
        p-orientation="horizontal"
        [p-value]="compileKey.payload.iss">
      </po-info>

      <po-info
        class="po-md-9 thf-mb-sm-6 thf-mb-md-9 thf-lb-lg-9"
        p-label="Emitido para"
        p-orientation="horizontal"
        [p-value]="compileKey.payload.sub">
      </po-info>

      <po-info
        class="po-md-9 thf-mb-sm-6 thf-mb-md-9 thf-lb-lg-9"
        p-label="Tipo"
        p-orientation="horizontal"
        [p-value]="compileKey.payload.auth">
      </po-info>

      <po-info
        class="po-md-9 thf-mb-sm-6 thf-mb-md-9 thf-lb-lg-9"
        p-label="Vencimento"
        p-orientation="horizontal"
        [p-value]="compileKey.payload.exp">
      </po-info>

      <po-textarea
        class="po-sm-12"
        name="compileKey"
        [(ngModel)]="compileKey.token"
        p-label="Compile Key"
        p-readonly
        p-rows="4"
      />

      <po-button
        class="po-lg-12 po-mt-2"
        (p-click)="downloadPATAToken()"
        p-label="Baixar token de compilação"
        p-icon="po-icon-download"
        [p-disabled]="pataTokenDownloadDisabled"
        [p-loading]="null"
      />
    </div>

    <po-loading-overlay *ngIf="!compileKey?.token" p-size="md" p-text="Gerando token" />
  </po-container>

</po-modal>



<!-- Input de upload sempre presente no DOM para triggerFileInput() funcionar -->
<input 
  type="file" 
  id="profileImageInput"
  hidden 
  accept="image/*"
  (change)="onProfileImageSelected($event)">

<!-- Popover Customizado do Perfil -->
<div class="profile-popover-container" *ngIf="showProfilePopover">
  <div class="profile-popover-backdrop" (click)="closeProfilePopover()"></div>
  <div class="profile-popover" (click)="showAvatarMenu = false">
    <div class="profile-popover-content">
      <!-- Header: Sair no canto direito -->
      <div class="profile-popover-area-header">
        <po-button
          class="profile-popover-logout-btn"
          p-label="Sair"
          p-icon="po-icon-exit"
          p-size="small"
          p-kind="tertiary"
          (p-click)="mainservice.logout()">
        </po-button>
      </div>

      <!-- Avatar + Info ao lado (Nome + Botão) -->
      <div class="profile-popover-main-section">
        <!-- Avatar à esquerda -->
        <div class="profile-popover-avatar">
          <div class="avatar-upload-container" (click)="$event.stopPropagation()">
            <div 
              *ngIf="userProfileImage"
              class="avatar-image"
              [style.backgroundImage]="'url(' + userProfileImage + ')'"
              style="cursor: pointer;">
            </div>
            <po-avatar
              *ngIf="!userProfileImage"
              [p-initials]="getUserInitials()"
              p-size="md">
            </po-avatar>
            <button 
              class="avatar-upload-btn" 
              (click)="showAvatarMenu = !showAvatarMenu; $event.stopPropagation()">
              <i class="po-icon po-icon-edit"></i>
            </button>
            
            <!-- Menu Dropdown -->
            <div class="avatar-dropdown-menu" *ngIf="showAvatarMenu" (click)="$event.stopPropagation()">
              <button 
                class="avatar-menu-item" 
                (click)="triggerFileInput(); showAvatarMenu = false"
                [ngClass]="{'add': !userProfileImage}">
                <i class="po-icon" [ngClass]="userProfileImage ? 'po-icon-edit' : 'po-icon-plus'"></i>
                {{ userProfileImage ? 'Trocar foto' : 'Adicionar foto' }}
              </button>
              <button 
                *ngIf="userProfileImage"
                class="avatar-menu-item delete" 
                (click)="removeProfileImage(); showAvatarMenu = false">
                <i class="po-icon po-icon-delete"></i> Deletar foto
              </button>
            </div>
          </div>
        </div>
        <!-- Nome e Botão à direita -->
        <div class="profile-popover-info-section">
          <div class="profile-popover-name">
            {{ getFullName() }}
          </div>
          <div class="profile-popover-area-badge">
            {{ mainservice.userToken.area }}
          </div>
          <div class="profile-popover-tribe" *ngIf="mainservice.userToken.tribeName">
            {{ mainservice.userToken.tribeName }}
          </div>
        </div>
      </div>

      <!-- Tags de Acesso -->
      <div class="profile-popover-tags" *ngIf="userRoleTags.length; else noAccessTag">
        <po-tag
          *ngFor="let tag of userRoleTags"
          [p-value]="tag.label"
          [p-color]="tag.color"
          [p-text-color]="tag.textColor">
        </po-tag>
      </div>
      <ng-template #noAccessTag>
        <div class="profile-popover-tags">
          <po-tag
            p-value="Nenhum acesso"
            p-color="color-07">
          </po-tag>
        </div>
      </ng-template>

      <!-- Tags de Acesso fim -->

      <!-- Ação principal: Token de compilação -->
      <div class="profile-popover-actions">
        <span
          class="profile-popover-button-token-wrapper"
          [title]="isDeveloper ? 'Gerar token de compilação' : 'Você não tem acesso ao token de compilação. Procure o GCAD para solicitar o acesso.'">
          <po-button
            class="profile-popover-button-token"
            p-label="Token de compilação"
            p-icon="an an-key"
            p-kind="secondary"
            p-size="small"
            [p-disabled]="!isDeveloper"
            [p-aria-label]="isDeveloper ? 'Token de compilação' : 'Token de compilação indisponível. Procure o GCAD para solicitar o acesso.'"
            (p-click)="openCompileKeyFromProfile()">
          </po-button>
        </span>
      </div>
    </div>
  </div>
</div>
